import AccountPayableListModal from '@/components/_common/AccountPayableListModal';
import { InstallmentSituation } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';

import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';
interface Props {
  value?: number;
}

function PayOverdue({ value }: Props) {
  const [viewAccountPayablesOpen, viewAccountPayablesActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de parcelas do contas a pagar com data de vencimento anterior ao dia atual que ainda está com situação em aberto."
        statisticTitle="A pagar vencidas | Qtde."
        color={StatisticDashboardTypeColor.expense}
        value={value}
        module={StatisticDashboardModule.accountPayable}
        onClick={viewAccountPayablesActions.open}
      />

      <AccountPayableListModal
        open={viewAccountPayablesOpen}
        onCancel={viewAccountPayablesActions.close}
        queryFilter={{
          situation: InstallmentSituation.open,
          finalDueDate: moment().subtract(1, 'day').format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default PayOverdue;
